import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { ContentCuidafarma } from "./ContentCuidafarma";
import { ContentGiftCard } from "./ContentGiftCard";
import { ContentTravel } from "./ContentTravel";
import { setExperimentBenefits } from "@/redux/actions/experiment";

import "./styles.scss";

const variantComponents = {
  isActive: ContentTravel,
  isActiveVersionA: ContentCuidafarma,
  isActiveVersionB: ContentGiftCard,
};

export const BannerBenefits = () => {
  const { experimentBenefits } = useSelector((state) => state.experiment);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!experimentBenefits) {
      window.showExperimentBenefits = () => {
        const { isActive, isActiveVersionA, isActiveVersionB } =
          window.experimentBenefits || {};
        if (isActive || isActiveVersionA || isActiveVersionB) {
          dispatch(setExperimentBenefits(window.experimentBenefits));
        }
      };
    }
  }, [experimentBenefits]);

  if (!experimentBenefits) return null;

  const ActiveComponent = Object.entries(variantComponents).find(
    ([key]) => experimentBenefits[key]
  )?.[1];

  return ActiveComponent ? <ActiveComponent /> : null;
};
